import { useQuery } from "@tanstack/react-query";

import { useApplication } from "@olist/microfrontend";

import { TicketDataQueryKeys } from "./queryKeys";
import { supportTicketsService } from "./services";

interface IUseGetTicketDataParams {
  id?: string;
}

export function useGetTicketData({ id }: IUseGetTicketDataParams) {
  const context = useApplication();
  const accessToken = context?.accessToken || "";

  const { data, isError, isLoading } = useQuery({
    queryKey: [TicketDataQueryKeys.DETAILS, id],
    queryFn: () => supportTicketsService.fetchTicket(accessToken, id),
    refetchOnWindowFocus: false,
    enabled: !!id,
    staleTime: 1000 * 60 * 5,
  });

  return {
    ticket: data,
    isLoading,
    isError,
  };
}
